import { getShortZoneName } from 'src/app/shared/helper/timezone-utils';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ClindxMat2ServiceService {
  private readonly DEFAULT_DATE_STRING = '0001-01-01T00:00:00';

  constructor(private datePipe: DatePipe) { }

  dateDisplayCheck(date: Date) {
    return (date?.toString() === this.DEFAULT_DATE_STRING) ?
      '' : this.datePipe.transform(date, 'MM/dd/yyyy');
  }

  fullDateDisplayCheck(date: Date) {
    return (date?.toString() === this.DEFAULT_DATE_STRING) ?
      '' : this.datePipe.transform(date, 'MM/dd/yyyy, hh:mm a');
  }

  datePerticularDisplayCheck(date: Date) {
    return (date?.toString() === this.DEFAULT_DATE_STRING) ?
      '' : (date) ? this.localDateConverter(date) : '';
  }

  isDetailEmpty(element: any[]) {
    if (element.filter(x => x.detail).length > 0 ||
      element.filter(x => x.detail !== null)) {
      return true;
    } else {
      return false;
    }
  }

  // dateParticularDisplayConvert(date: Date, timeZone: string) {
  //   return (date && date.toString() === '0001-01-01T00:00:00') ?
  //     '' : (date) ? this.dateDisplayformatChange(date, timeZone) : '';
  // }

  // private dateDisplayformatChange(date: Date, timeZone: string) {
  //   const result = (timeZone.match(new RegExp('[A-Z](?!.*[\(])', 'g')).join(''));
  //   const dateDisplay = this.datePipe.transform(date, 'MM/dd/yyyy hh:mm a') + ' ' + result;
  //   return dateDisplay;
  // }

  private localDateConverter(date: Date) {
    const locale = Constants.LOCALE_ID;
    const userDate = this.parseUTC(date);
    const clientDateTimeStr = userDate.toLocaleString(locale, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
    const result = getShortZoneName();
    const dateDisplay = this.datePipe.transform(clientDateTimeStr, 'MM/dd/yyyy, hh:mm a') + ' ' + result;
    return dateDisplay;
  }

  private parseUTC(s) {
    const b = s.split(/\D/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
  }
}
